import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { SSOConnection_Read } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

const formatIdentityProvider = (value: string): string =>
  value
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

interface SignInWithSSOFormProps {
  ssoConnections: SSOConnection_Read[];
}

const SignInWithSSOForm = ({ ssoConnections }: SignInWithSSOFormProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {ssoConnections.map((conn, index) => (
        <Box
          key={conn.stytch_connection_id ?? `sso-${index}`}
          sx={{ mb: 1, width: '100%' }}
        >
          <Button
            fullWidth
            color="inherit"
            sx={{ backgroundColor: 'action.disabledBackground' }}
            variant="contained"
            component="a"
            href={conn.start_url}
          >
            {t('actions.sign_in_with_sso_provider', {
              identity_provider: formatIdentityProvider(conn.stytch_identity_provider!),
            })}
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default SignInWithSSOForm;
